export default (cpf: string) => {
  const p1 = cpf.substring(0, 3);
  const p2 = cpf.substring(3, 6);
  const p3 = cpf.substring(6, 9);
  const p4 = cpf.substring(9, 11);
  return `${p1}.${p2}.${p3}-${p4}`;
};
